let ctx;
const KEY = "clipx_panel_sound";

export const soundOn = () => localStorage.getItem(KEY) !== "0";
export const setSoundOn = (v) => localStorage.setItem(KEY, v ? "1" : "0");

const tone = (ac, f0, f1, at, dur, vol = 0.25) => {
  const o = ac.createOscillator();
  const g = ac.createGain();
  o.type = "triangle";
  o.frequency.setValueAtTime(f0, ac.currentTime + at);
  o.frequency.exponentialRampToValueAtTime(f1, ac.currentTime + at + dur);
  g.gain.setValueAtTime(0.0001, ac.currentTime + at);
  g.gain.exponentialRampToValueAtTime(vol, ac.currentTime + at + 0.02);
  g.gain.exponentialRampToValueAtTime(0.0001, ac.currentTime + at + dur);
  o.connect(g).connect(ac.destination);
  o.start(ac.currentTime + at);
  o.stop(ac.currentTime + at + dur + 0.05);
};

export const feedback = (kind) => {
  if (!soundOn()) return;
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    if (ctx.state === "suspended") ctx.resume();
    if (kind === "launch") { tone(ctx, 420, 980, 0, 0.14); tone(ctx, 980, 1400, 0.12, 0.12, 0.18); }
    else if (kind === "ready") { tone(ctx, 880, 880, 0, 0.16, 0.2); tone(ctx, 1320, 1320, 0.16, 0.26, 0.2); }
    else tone(ctx, 220, 160, 0, 0.25, 0.2);
  } catch (_) {}
  navigator.vibrate?.(kind === "launch" ? [80, 40, 160] : kind === "ready" ? [60, 60, 60] : [300]);
};
